import { render } from "./TranslucentTable.vue?vue&type=template&id=5fe54e96"
import script from "./TranslucentTable.vue?vue&type=script&lang=js"
export * from "./TranslucentTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__